
import { Component, Vue, Watch } from 'vue-property-decorator';

import axios from 'axios'

@Component({
  name: 'Default'
})
export default class Default extends Vue {
  private pass: string = '';
  private npass: string = '';

  get user() { return this.$store.getters['user/current'] };
  get error() { return !!this.informers.filter(i => i.status === 'error').length };
  get informers() { return this.$store.getters['usernew/pass_informers'] };

  @Watch('pass')
  passChanged(val) {
    this.set_change(true);
  };

  @Watch('npass')
  npassChanged() {
    this.check_pass();
    this.set_change(true);
  };

  public check_pass() {
    this.$store.dispatch('usernew/check_pass', {password: this.npass});
  };
  public save() {
    if(this.npass !== '') {
      this.set_change(false);
      axios.put('/1.0/users', {users: [
        {password: this.npass, old_password: this.pass, email: this.user.email}
      ]}).then(r => {
        this.$noty.success(this.$tr('profile.password.save_success') + '.');
      }).catch(e => {
        if(e.response === undefined) {
          this.$noty.error(this.$tr('common.error.networkError'));
        } else {
          this.$noty.error(e.response.data.meta.error.message + '.') // this.$tr('profile.password.save_error')
        }
      });
    } else {
      this.$noty.error(this.$tr('profile.password.empty') + '.')
    }
  };
  public set_change(val) {
    this.$store.commit('user/set_change_user', val);
  };

  /*
  #TODO
  переделать механизм сохранения, сделать сейв через стору
  */
  mounted() {
    this.$parent.$parent.$parent.$on('save', this.save);
  };
  beforeDestroy() {
    this.$parent.$parent.$parent.$off('save');
    this.$store.commit('usernew/clear');
  };
}
